export const rootStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  paddingX: 1.5,
  paddingY: 1,
  borderBottom: ({ palette }) => `1px solid ${palette.divider}`,
  backgroundColor: ({ palette }) => palette.action.hover,
};

export const headerStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  color: ({ palette }) => palette.text.secondary,
};

export const headerLabelStyles = {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
};

export const itemStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  paddingX: 1,
  paddingY: 0.5,
  borderRadius: 1,
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: ({ palette }) => palette.action.selected,
  },
};

export const itemBodyStyles = {
  flex: 1,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: ({ palette }) => palette.text.primary,
  display: 'flex',
  alignItems: 'baseline',
  gap: 0.75,
  minWidth: 0,
};

export const itemSenderStyles = {
  color: ({ palette }) => palette.text.primary,
  flexShrink: 0,
};

export const itemPreviewStyles = {
  color: ({ palette }) => palette.text.secondary,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  minWidth: 0,
};
